function carousel(name) {
    document.querySelectorAll(name).forEach(carousel => new Splide(carousel, {
        pagination: true,
        arrows: true
    }).mount());
}